import Api from "./service";
import {notification} from "antd";
import LocalStorage from "../tools/LocalStorage";
const Request = (url: string, body: any) => {
    const Token=LocalStorage.getToken();
    const branchInfo=LocalStorage.getBranchInfo();
    console.log(branchInfo)
    const data={...body,BillId:branchInfo.bill_id}
     return Api.post(url, data,{
         timeout:60000,
         headers: {
             "Authorization": Token.token_type + " " + Token.access_token
         }
     }).then((response: any) => {
        if (response.data.Status == 0) {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
            return {data:response.data.Data,message:response.data.Message}
        } else {

            notification['error']({
                message: 'نا موفق',
                description: response.data.Message,
                duration: 120
            });
            return false
        }
    }).catch((e)=>{
         notification['error']({
             message: 'نا موفق',
             description: 'عملیات نا موفق بوده است.',
             duration: 120
         });
     })

}
export default Request;